import PropTypes from 'prop-types';

export const lcSideFilterType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  filtersCollection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
      }).isRequired
    ),
  }),
});

export const lcSideFilterProps = {
  handleFilter: PropTypes.func.isRequired,
  filterTypes: [lcSideFilterType].isRequired,
};
